import { memo, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Redirect } from 'react-router-dom';

import { getMobileOperatingSystem, getTeachSubscriptionNumClasses, moveToScrollToElem, userHasSubscription } from '../../utils';

import BottomMenu from '../../components/BottomMenu';

import SectionHeader from '../../components/Utils/SectionHeader';
import { loadSubscriptions, TEACHERPRODUCTS } from '../../modules/subscription';
import { unlockScreen } from '../../utils/screen';

import { recordPageGA } from '../../modules/ga';

import { useHistory } from "react-router-dom";

import '../Learn/index.less';
import './index.less';

import { BookOutlined, DeploymentUnitOutlined } from '@ant-design/icons';
import { Tabs } from 'antd';
import ModalLoader from '../../components/Course/ModalLoader';
import SubscribeButton from '../../components/Subscription/SubscribeButton';
import SubscriptionOptions from '../../components/Subscription/SubscriptionOptions';
import ClassDetails from '../../components/teach/ClassDetails';
import ClassesList from '../../components/teach/ClassesList';
import CompetitionDetails from '../../components/teach/CompetitionDetails';
import CompetitionsList from '../../components/teach/CompetitionsList';
import CreateClass from '../../components/teach/CreateClass';
import CreateClassButton from '../../components/teach/CreateClassButton';
import CreateCompetition from '../../components/teach/CreateCompetition';
import CreateCompetitionButton from '../../components/teach/CreateCompetitionButton';
import JoinClass from '../../components/teach/JoinClass';
import { t } from '../../languages';
import { createAClass, deleteUserClass, loadAClass, loadUserClasses, resetCurrent } from '../../modules/aclass';
import { createCompetition, deleteUserCompetition, loadCompetition, loadUserCompetitions, resetCurrentCompetition, sendCompetitionResponse, updateCompetitionFields } from '../../modules/competition';
import { switchToFullscreen } from '../../modules/utils';
import { disconnectSocket } from '../../modules/websocket';

const HASSUBSCRIPTION = false;
const os = getMobileOperatingSystem().toLocaleLowerCase();

const AskForTeacherSubscription = ({ lang, max }) => {
  return (
    <div className="ask-for-teacher-subscription" >
      <h5 style={{ textAlign: 'center' }}>{t(lang, 'classLimitReached')}</h5>
      <SubscriptionOptions lang={'lang'} forTeach={true} hasTeacherSubscription={false} />
      <br />
      <br />
      <br />
      <br />
    </div >
  );
}

const Teach = ({
  user,
  results,
  lang,
  isLoading,
  transactions,
  products,
  loadSubscriptions,

  classes, currentClass,
  loadUserClasses, createAClass, resetCurrent, loadAClass, deleteUserClass,

  competitions, currentCompetition,
  loadUserCompetitions, createCompetition, resetCurrentCompetition, loadCompetition, deleteUserCompetition, updateCompetitionFields, sendCompetitionResponse
}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalOption, setModalOption] = useState(null);
  const [hasSubscription, setHasSubscription] = useState(HASSUBSCRIPTION);
  const [myPurchasedProducts, setMyPurchasedProducts]: [any, any] = useState(null);

  const history = useHistory();

  useEffect(() => {
    // console.log('Teach.useEffect[]....');
    recordPageGA('/teach');

    if (user) {
      loadUserClasses(user.id);
      loadUserCompetitions(user.id);
    }

    if (!products) loadSubscriptions();

    return () => {
      disconnectSocket();
    };

  }, []);

  const _evalHasSubscription = () => {
    let { hasSubscription, products } = userHasSubscription(transactions, user);

    setHasSubscription(hasSubscription);
    setMyPurchasedProducts(products);
  }

  useEffect(() => {
    // console.log('useEffect[transactions]...');
    if (transactions) {
      _evalHasSubscription();
    }
  }, [transactions]);

  useEffect(() => {
    // console.log('useEffect[user]...');
    if (user) {
      _evalHasSubscription();
    }
  }, [user]);


  useEffect(() => {
    if (results) {
      // console.log('Teach useEffect[results]:', results.current);
      moveToScrollToElem(results.current);
      // moveToScrollPoition();
    }
  }, [results]);

  useEffect(() => {
    const unblock = history.block((location, action) => {
      if (modalVisible) {
        setModalVisible(false);
        return false; // Prevent navigation
      }
    });

    return () => {
      unblock();
    };
  }, [modalVisible, setModalVisible, history]);

  useEffect(() => {
    if (!modalVisible) unlockScreen();
  }, [modalVisible]);

  /* Handlers */

  const handleCancel = e => {
    setModalVisible(false);
  };

  const handleOk = e => {
    setModalVisible(false);
  };

  /* Class Handlers */

  const handleOnClassCreate = classData => {
    console.log('Teach.handleOnClassCreate:', classData);
    classData.teacher = user.id;
    createAClass(classData);
    setModalTitle(<h2><BookOutlined className="class-icon" /> {classData.name}</h2>);
    setModalOption('classDetails');
  };

  const handleOnJoin = classData => {
    console.log('Teach.handleOnJoin:', classData);
    setModalVisible(false);
  };

  const handleModalOption = option => {
    resetCurrent();
    setModalTitle(<h2>{t(lang, option)}</h2>);
    setModalOption(option);
    setModalVisible(true);
  }

  const handleClassClicked = aClass => {
    // console.log('Teach.handleClassClicked:', aClass);
    setModalTitle(<h2><BookOutlined className="class-icon" /> {aClass.name}</h2>);
    setModalOption('classDetails');
    loadAClass(aClass.id);
    setModalVisible(true);

    switchToFullscreen();
  }

  const handleDeleteClass = (teacher, cid) => {
    // console.log('Teach.handleDeleteClass:', teacher, cid);
    deleteUserClass(teacher, cid);
    setModalVisible(false);
  }

  /* Competition Handlers */

  const handleCompetitionClicked = aComp => {
    // console.log('Teach.handleCompetitionClicked:', aComp);
    setModalTitle(<h2><DeploymentUnitOutlined className="class-icon" /> {aComp.name}</h2>);
    setModalOption('competitionDetails');
    loadCompetition(aComp.id);
    setModalVisible(true);

    switchToFullscreen();
  }

  const handleOnCompetitionCreate = competitionData => {
    // console.log('Teach.handleOnCompetitionCreate:', competitionData);
    competitionData.teacher = user.id;
    createCompetition(competitionData);
    setModalTitle(<h2><DeploymentUnitOutlined className="class-icon" />  {competitionData.name}</h2>);
    setModalOption('competitionDetails');
  };

  const handleDeleteCompetition = (teacher, cid) => {
    // console.log('Teach.handleDeleteClass:', teacher, cid);
    deleteUserCompetition(teacher, cid);
    setModalVisible(false);
  }

  const handleCompetitionUpdate = (fields) => {
    // console.log('Teach.handleCompetitionUpdate:', fields);
    updateCompetitionFields(fields);
  }

  const handleExpireTime = (eid) => {
    if (currentCompetition && (currentCompetition.responses && currentCompetition.responses[eid])) {
      // console.log(`Teach.handleExpireTime: already responses for exercise ${eid} in competition ${currentCompetition.id}`);
    } else {
      // console.log(`Teach.handleExpireTime:`, eid, currentCompetition.id);
      sendCompetitionResponse(currentCompetition.id, eid, null);
    }
  }


  const divStyle: any = {
    // height: `${innerHeight - 53}px`,
    overflowX: 'hidden',
    overflowY: 'scroll',
    paddingBottom: '53px'
  };

  // console.log('Teach: classes:', classes, currentClass);

  if (!user) return <Redirect to="/profile/login" />;
  else {
    let modalContent = null;

    const { hasTeacherSubscription, maxNumClasses } = getTeachSubscriptionNumClasses(myPurchasedProducts, TEACHERPRODUCTS[os]);
    // console.log('Teach: myPurchasedProducts:', myPurchasedProducts, 'hasSubscription:', hasSubscription, 'hasTeacherSubscription:', hasTeacherSubscription, 'classes:', classes, 'maxNumClasses:', maxNumClasses);

    if (modalOption === 'createClass') {
      const numClasses = classes ? classes.length : 0;
      if ((hasSubscription && hasTeacherSubscription) || numClasses < 1) {
        console.log('Teach: numClasses:', numClasses, 'maxNumClasses:', maxNumClasses);
        if (numClasses < maxNumClasses) {
          modalContent = (<CreateClass lang={lang} onCreate={handleOnClassCreate} onCancel={handleCancel} />);
        } else modalContent = <AskForTeacherSubscription max={maxNumClasses} lang={lang} />;
      } else modalContent = <AskForTeacherSubscription max={1} lang={lang} />;
    }
    else if (modalOption === 'joinClass') modalContent = (<JoinClass lang={lang} onJoin={handleOnJoin} onCancel={handleCancel} />);
    else if (modalOption === 'classDetails' && currentClass) modalContent = (<ClassDetails lang={lang} theClass={currentClass} loadAClass={loadAClass} onDelete={handleDeleteClass} />);
    else if (modalOption === 'createCompetition') modalContent = (<CreateCompetition lang={lang} classes={classes} onCreate={handleOnCompetitionCreate} onCancel={handleCancel} hasTeacherSubscription={hasSubscription && hasTeacherSubscription} />);
    else if (modalOption === 'competitionDetails' && currentCompetition) {
      const theClass = classes.find(aC => aC.id == currentCompetition.class);
      modalContent = (<CompetitionDetails lang={lang} theCompetition={currentCompetition} loadCompetition={loadCompetition} theClass={theClass} onDelete={handleDeleteCompetition} onUpdate={handleCompetitionUpdate} onExpireTime={handleExpireTime} />);
    }

    return (
      <section className='MiSoroban'>
        <div style={divStyle} className="learn teach">

          <div className='mis-wrapper'>
            <SectionHeader section={'teach'} />
            <div className='teach-body'>
              <h5>{t(lang, 'teachsubtitle')}</h5>

              <Tabs defaultActiveKey="classes">
                <Tabs.TabPane tab={t(lang, 'classes')} key="classes">
                  <CreateClassButton lang={lang} modalOption={handleModalOption} />
                  <ClassesList lang={lang} classes={classes} onClassClick={handleClassClicked} />
                </Tabs.TabPane>
                <Tabs.TabPane tab={t(lang, 'competitions')} key="competitions">
                  <CreateCompetitionButton lang={lang} modalOption={handleModalOption} />
                  <CompetitionsList lang={lang} competitions={competitions} classes={classes} onCompetitionClick={handleCompetitionClicked} />
                </Tabs.TabPane>
              </Tabs>


              <br />
              {(classes && classes.length && !(hasSubscription && hasTeacherSubscription)) ? <SubscribeButton lang={lang} show={!hasTeacherSubscription} forTeach={true} /> : null}
            </div>
          </div>
        </div>

        <ModalLoader
          title={modalTitle}
          visible={modalVisible}
          handleOk={handleOk}
          handleCancel={handleCancel}
          content={modalContent}
          className="exercise-modal teach-modal"

        />

        <BottomMenu section={'teach'} />
      </section>
    );
  }
};

const mapStateToProps = ({ user, aclass, subscription, competition }) => ({
  user: user.user,
  isLoading: aclass.isFetching || competition.isFetching,
  lang: user.lang,
  products: subscription.products,
  transactions: subscription.transactions,
  classes: aclass.data,
  currentClass: aclass.current,
  competitions: competition.data,
  currentCompetition: competition.current,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loadSubscriptions,

      loadUserClasses,
      createAClass,
      resetCurrent,
      loadAClass,
      deleteUserClass,

      createCompetition,
      loadUserCompetitions,
      resetCurrentCompetition,
      loadCompetition,
      deleteUserCompetition,
      updateCompetitionFields,
      sendCompetitionResponse
    },
    dispatch
  );

export default memo(connect(mapStateToProps, mapDispatchToProps)(Teach));
